import type { Painter } from '../rendering/Painter';
import { overlayTokens } from '../styles/tokens';
import type { InfoPanelVM } from '../vm/types';

export class InfoPanel {
    render(painter: Painter, vm: InfoPanelVM): void {
        painter.panel(vm.rect, 'rgba(0,0,0,0.6)', 'rgba(0,0,0,0)');
        vm.lines.forEach((line) => {
            painter.text(
                line.text,
                vm.rect.x + 8,
                vm.rect.y + line.offsetY,
                overlayTokens.colors.text,
                overlayTokens.fonts.small,
            );
        });
    }
}
